function RenderFinalScore({ finalScore }) {
  // Simple translation function
  const t = (k) => (window.accessI18n?.[k] ?? k);

  if (finalScore === undefined || finalScore === null || isNaN(finalScore)) {
    return <p>{t("No score available.")}</p>;
  }

  return (
    <>
      <div
        className="progress h-auto fs-3 fw-bold mb-4 mb-xl-6"
        role="progressbar"
        aria-label="Success example"
        aria-valuenow={finalScore}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div
          className={
            "progress-bar " +
            (finalScore > 89 ? "bg-success" : "") +
            ((finalScore > 49 && finalScore < 90) ? "bg-warning" : "") +
            ((finalScore > 0 && finalScore < 50) ? "bg-danger" : "")
          }
          style={{ width: `${finalScore}%` }}
        >
          {finalScore}%
        </div>
      </div>
    </>
  );
}

export default RenderFinalScore;
